let observer;

document.addEventListener("DOMContentLoaded", () => {
  initPolaroidGrid();
});

if (document.readyState === "interactive" || document.readyState === "complete") {
  initPolaroidGrid();
}

function initPolaroidGrid() {
  console.log("initPolaroidGrid called");
  observer = new MutationObserver((mutations) => {
    if (observer) observer.disconnect();
    updatePolaroidGrid();
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  updatePolaroidGrid();
}

function updatePolaroidGrid() {
  const fileWrappers = document.querySelectorAll(".selector-wrapper.bcpo-file");
  if (fileWrappers.length === 0) return;

  fileWrappers.forEach((wrapper) => {
    if (wrapper.getAttribute("data-custom-polaroid-init") === "true") {
      return;
    }

    const input = wrapper.querySelector("input[type='file']");
    if (!input) return;

    wrapper.setAttribute("data-custom-polaroid-init", "true");

    // Hide bcpo-label and extract title/number
    const label = wrapper.querySelector(".bcpo-label");
    let numText = "";
    if (label) {
      const titleSpan = label.querySelector(".bcpo-title");
      if (titleSpan) {
        numText = titleSpan.textContent.replace(":", "").trim();
      }
      label.style.display = "none";
    }

    // Create custom UI elements
    const cardContent = document.createElement("div");
    cardContent.className = "bcpo-custom-card-content";

    const badge = document.createElement("div");
    badge.className = "bcpo-custom-card-badge";
    badge.textContent = numText || "";

    const preview = document.createElement("div");
    preview.className = "bcpo-custom-card-preview";

    const previewText = document.createElement("span");
    previewText.className = "bcpo-custom-card-preview-text";
    previewText.textContent = "Empty";
    preview.appendChild(previewText);

    const button = document.createElement("div");
    button.className = "bcpo-custom-card-button";
    button.textContent = "Choose File";

    cardContent.appendChild(badge);
    cardContent.appendChild(preview);
    cardContent.appendChild(button);

    // Insert cardContent before the input
    wrapper.insertBefore(cardContent, input.parentElement);

    // Listen to changes
    input.addEventListener("change", (e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          preview.innerHTML = `<img src="${event.target.result}" class="bcpo-custom-card-image-preview" />`;
          wrapper.classList.add("has-file");
          updateStatusMessage();
        };
        reader.readAsDataURL(file);
      } else {
        preview.innerHTML = "";
        preview.appendChild(previewText);
        wrapper.classList.remove("has-file");
        updateStatusMessage();
      }
    });
  });

  updateStatusMessage();
}

function updateStatusMessage() {
  const fileWrappers = document.querySelectorAll(".selector-wrapper.bcpo-file");
  const total = fileWrappers.length;
  if (total === 0) return;

  const selected = Array.from(fileWrappers).filter(wrapper => wrapper.classList.contains("has-file")).length;

  const bcpoContainer = document.getElementById("bcpo");
  let statusMsg = document.querySelector(".bcpo-custom-grid-status");
  if (!statusMsg) {
    statusMsg = document.createElement("div");
    statusMsg.className = "bcpo-custom-grid-status";
    if (bcpoContainer) {
      bcpoContainer.appendChild(statusMsg);
    } else {
      const lastWrapper = fileWrappers[fileWrappers.length - 1];
      lastWrapper.parentNode.insertBefore(statusMsg, lastWrapper.nextSibling);
    }
  }

  if (selected < total) {
    statusMsg.textContent = "Select all " + total + " images to continue.";
    statusMsg.classList.remove("all-selected");
  } else {
    statusMsg.textContent = "All " + total + " images selected!";
    statusMsg.classList.add("all-selected");
  }
}
